import { createStyles } from '@mantine/core';
import styled from 'styled-components';

export const useStyles = createStyles(() => {
  return {
    dropdown: {
      boxShadow: 'none',
      border: 'none',
      borderRadius: 'unset',
      padding: 0,
    },
  };
});

export const ButtonContainer = styled.div`
  position: relative;
`;
